'use strict';

var util = require('../util/property-util');
var operatorCodes = require('../util/operator-codes');
var MessageDescriptorConvertFactory = require('../shared/messageDescriptorConvertFactory');


module.exports = {
    createDescriptor: function (name, axisType, propertyLabel, staticLegend, vuSpecific) {

        vuSpecific = util.isDefined(vuSpecific) ? vuSpecific : false;
        staticLegend = util.isDefined(staticLegend) ? staticLegend : false;

        return {
            'name': name,
            'axis': axisType,
            'label': `I18N_DESCRIPTOR.${name.toUpperCase()}`,
            'unit': '',
            'vuSpecific': vuSpecific,
            "discriminatedObjectLabel": name,
            'staticLegend': staticLegend,
            'checked': false
        };
    },

    createAxisType: function (type, color, width, unit, balloonFunction, position, labelsEnabled, labelFunction) {
        return {
            'type': util.isDefined(type) ? type : 'unknown-type',
            'unit': util.isDefined(unit) ? ' ' + unit : '',
            'color': util.isDefined(color) ? color : 'black',
            'width': util.isDefined(width) ? width : 75,
            'balloonFunction': util.isDefined(balloonFunction) ? balloonFunction : function (graphDataItem) {
                return graphDataItem.values.value + ' ' + unit;
            },
            'position': util.isDefined(position) ? position : 'left',
            'labelsEnabled': util.isDefined(labelsEnabled) ? labelsEnabled : true,
            'labelFunction': util.isDefined(labelFunction) ? labelFunction : function (value) {
                if (value > 9999) {
                    return value.toPrecision(2) + ' ' + unit;
                } else {
                    if (value % 1 != 0) {
                        return value.toFixed(2) + ' ' + unit;
                    } else {
                        return value.toFixed(0) + ' ' + unit;
                    }

                }
            }
        }
    },

    createHighChartYAxisType: function (type, color, unit, formatFunction, position, labelsEnabled, labelFunction, options) {

        var targetUnit = '';
        if (util.isDefined(unit)) {
            if (util.isFunction(unit)) {
                targetUnit = unit(options);
            } else {
                targetUnit = '' + unit;
            }
        } else {
            targetUnit = '';
        }

        return {
            'type': util.isDefined(type) ? type : 'unknown-type',
            'unit': targetUnit,
            'color': util.isDefined(color) ? color : 'black',
            'formatFunction': util.isDefined(formatFunction) ? formatFunction : function (value, targetUnit) {
                if (!util.isDefined(targetUnit)) {
                    return value;
                } else {
                    return value + ' ' + targetUnit;
                }
            },
            'position': util.isDefined(position) ? position : 'left',
            'labelsEnabled': util.isDefined(labelsEnabled) ? labelsEnabled : true,
            'labelFunction': util.isDefined(labelFunction) ? labelFunction : function (value, targetUnit) {
                return value + ' ' + targetUnit;
            }
        }
    },

// var MessageDescriptorConvertFactory = MessageDescriptorConvertFactory || {};
//
// MessageDescriptorConvertFactory.init = function () {
//     this.data = new Map();
//     this.conversions = new Map();
//     this.mapping = new Map();
//     this.loadConversion();
// };
//
// MessageDescriptorConvertFactory.loadConversion = function () {
//     this.conversions.set("B1", "2100 MHz");
//     this.conversions.set("B2", "1900 PCS MHz");
//     this.conversions.set("B3", "1800 MHz");
//     this.conversions.set("B4", "1700/2100 MHz");
//     this.conversions.set("B5", "850 MHz");
//     this.conversions.set("B7", "2600 MHz");
//     this.conversions.set("B8", "900 MHz");
//     this.conversions.set("B9", "1800 MHz");
//     this.conversions.set("B11", "1500 MHz Lower");
//     this.conversions.set("B12", "700 MHz ac");
//     this.conversions.set("B13", "700 MHz c");
//     this.conversions.set("B17", "700 MHz bc");
//     this.conversions.set("B18", "800 MHz Lower");
//     this.conversions.set("B19", "800 MHz Upper");
//     this.conversions.set("B20", "800 MHz DD");
//     this.conversions.set("B21", "1500 MHz Upper");
//     this.conversions.set("B25", "1900+ MHz");
//     this.conversions.set("B26", "850 + MHz");
//     this.conversions.set("B28", "700 MHz APT");
//     this.conversions.set("B30", "2300 MHz WCS");
//     this.conversions.set("B38", "TD 2600 MHz");
//     this.conversions.set("B39", "TD 1900 + MHz");
//     this.conversions.set("B40", "TD 2300 MHz");
//     this.conversions.set("B41", "TD 2500 MHz");
//     this.conversions.set(null, "Unknown");
// };
//
// MessageDescriptorConvertFactory.getKeyForObjectName = function (objectName) {
//     var value = this.mapping.get(objectName);
//     if (isDefined(value)) {
//         return value;
//     } else {
//         return null;
//     }
// };
//
// MessageDescriptorConvertFactory.convertStringToIndex = function (fieldName, value, objectName, useExactValue) {
//     if (!isDefined(value)) {
//         return null;
//     }
//     if (isDefined(objectName)) {
//         this.mapping.set(objectName, fieldName);
//     }
//     if (!useExactValue) {
//         value = value.trim();
//         value = formatStringForDisplay(value);
//     }
//
//     var fieldArray = this.data.get(fieldName);
//     if (!isDefined(fieldArray)) {
//         this.data.set(fieldName, []);
//         fieldArray = this.data.get(fieldName);
//     }
//     var index = fieldArray.indexOf(value);
//     if (index == -1) {
//         fieldArray.push(value);
//         index = fieldArray.indexOf(value);
//     }
//     return index + 1;
// };
//
// MessageDescriptorConvertFactory.convertIndexToString = function (fieldName, index) {
//     function isFloat(n) {
//         return n != "" && !isNaN(n) && Math.round(n) != n;
//     }
//
//     if (isFloat(index)) {
//         return "Undecided"
//     } else if (index == 0 || !isDefined(fieldName) || !isDefined(this.data.get(fieldName)) || !isDefined(this.data.get(fieldName)[index - 1])) {
//         return "Undefined";
//     }
//
//     var value = this.data.get(fieldName)[index - 1];
//     var convertedValue = this.conversions.get(value);
//
//     var returnValue = value;
//     if (isDefined(convertedValue)) {
//         returnValue = convertedValue;
//     }
//     return returnValue;
// };

    getAxisMetaByType: function (type, options) {
        var messageDescriptorConvertFactory = new MessageDescriptorConvertFactory();
        var axisTypes = {
            'bandwidth-MB': module.exports.createHighChartYAxisType('bandwidth-MB', 'black', 'MB', module.exports.bigNumberCommaSeparated, 'right'),
            'big-throughput-bytes': module.exports.createHighChartYAxisType('big-throughput-bytes', 'red', 'bytes', module.exports.bytesFormater, 'right', true, module.exports.bytesFormater),
            'big-throughput-bitspers': module.exports.createHighChartYAxisType('big-throughput-bitspers', 'red', 'bps', module.exports.bitsFormater, 'right', true, module.exports.bitsFormater),
            'big-throughput-kbps-combined': module.exports.createHighChartYAxisType('big-throughput-kbps-combined', 'black', 'kbps', null, 'right'),
            'big-throughput-kB': module.exports.createHighChartYAxisType('big-throughput-kB', 'red', 'kB', null, 'right'),
            'kbitspers': module.exports.createHighChartYAxisType('kbitspers', 'black', 'kbps', module.exports.kbitsFormater, 'right', true, module.exports.kbitsFormater),
            'boolean-up-down': module.exports.createHighChartYAxisType('boolean-up-down', 'green', '', module.exports.vpnUpToolboxFunction, 'right'),
            'zero-to-hundred': module.exports.createHighChartYAxisType('zero-to-hundred', 'blue', '%'),
            'temperature-celcius': module.exports.createHighChartYAxisType('temperature-celcius', 'blue', '°C'),
            'obis-lifesign': module.exports.createHighChartYAxisType('obis-lifesign', 'red', ''),
            'lac': module.exports.createHighChartYAxisType('lac', 'pink', 'lac', module.exports.lacToolboxFunction),
            'cell-id': module.exports.createHighChartYAxisType('cell-id', 'grey', 'cell-id', module.exports.cellidToolboxFunction),
            'avg-mar3-latency': module.exports.createHighChartYAxisType('avg-mar3-latency', 'purple', 'ms'),
            'zero-to-63': module.exports.createHighChartYAxisType('zero-to-63', 'CornflowerBlue ', 'ms'),
            'negative-dbm': module.exports.createHighChartYAxisType('negative-dbm', 'DarkOrchid ', 'dBm'),
            'db-axis': module.exports.createHighChartYAxisType('db-axis', 'SteelBlue ', 'dB'),
            'zero-to-350': module.exports.createHighChartYAxisType('zero-to-350', 'FireBrick ', 'ms'),
            'kmperh-axis': module.exports.createHighChartYAxisType('kmperh-axis', 'red', module.exports.speedUnit, null, null, null, null, options),
            'zero-to-50Mhz': module.exports.createHighChartYAxisType('zero-to-50Mhz', 'MediumAquaMarine', 'MHz'),
            'channel-axis': module.exports.createHighChartYAxisType('channel-axis', 'GreenYellow', ''),
            'gps-valid-scale': module.exports.createHighChartYAxisType('gps-valid-scale', 'ForestGreen', '', module.exports.gpsUpToolboxFunction),
            'small-number-scale': module.exports.createHighChartYAxisType('small-number-scale', 'Indigo', ''),
            'k-number-scale': module.exports.createHighChartYAxisType('k-number-scale', 'black', ''),
            'ms-number-scale': module.exports.createHighChartYAxisType('ms-number-scale', 'LawnGreen', 'ms'),
            'seconds-scale': module.exports.createHighChartYAxisType('seconds-scale', 'Purple', 's'),
            'micro-ms-number-scale': module.exports.createHighChartYAxisType('micro-ms-number-scale', 'LightSeaGreen', 'ms'),
            'tinyint-nounit-axis': module.exports.createHighChartYAxisType('tinyint-nounit-axis', 'red', ''),
            'milli-ampere-axis': module.exports.createHighChartYAxisType('milli-ampere-axis', 'SteelBlue ', 'mA', module.exports.microAmpereConversion, 'right', true, module.exports.microAmpereConversion),
            'cell-technology-axis': module.exports.createHighChartYAxisType('cell-technology-axis', 'MediumPurple', '', module.exports.technologyToolboxfunction, 'right', true, module.exports.technologyToolboxfunction),
            'network-type-axis': module.exports.createHighChartYAxisType('network-type-axis', 'Blue', '', module.exports.index2networkType, 'right', true, module.exports.index2networkType),
            'emm-state-axis': module.exports.createHighChartYAxisType('emm-state-axis', 'RoyalBlue', '', function (a) {
                return messageDescriptorConvertFactory.convertIndexToString('emm', a);
            }, 'right', false),
            'service-state-axis': module.exports.createHighChartYAxisType('service-state-axis', 'RebeccaPurple', '', function (a) {
                return messageDescriptorConvertFactory.convertIndexToString('service', a);
            }, 'right', false),
            'rrc-state-axis': module.exports.createHighChartYAxisType('rrc-state-axis', 'black', '', function (a) {
                return messageDescriptorConvertFactory.convertIndexToString('rrc', a);
            }, 'right', false),
            'ims-reg-state-axis': module.exports.createHighChartYAxisType('rrc-state-axis', 'IndianRed', '', function (a) {
                return messageDescriptorConvertFactory.convertIndexToString('ims', a);
            }, 'right', false),
            'band-axis': module.exports.createHighChartYAxisType('band-axis', 'Sienna', '', function (a) {
                return messageDescriptorConvertFactory.convertIndexToString('band', a);
            }, 'right', false),
            'ca-state-axis': module.exports.createHighChartYAxisType('ca-state-axis', 'Sienna', '', function (a) {
                return messageDescriptorConvertFactory.convertIndexToString('caState', a);
            }, 'right', false),
            'gmm-state-axis': module.exports.createHighChartYAxisType('gmm-state-axis', 'Turquoise', '', function (a) {
                return messageDescriptorConvertFactory.convertIndexToString('gmm', a);
            }, 'right', false),
            'plmn-state-axis': module.exports.createHighChartYAxisType('plmn-state-axis', 'Navy', '', function (a) {
                return messageDescriptorConvertFactory.convertIndexToString('plmn', a);
            }, 'right', false),
            'mm-state-axis': module.exports.createHighChartYAxisType('mm-state-axis', 'MediumVioletRed', '', function (a) {
                return messageDescriptorConvertFactory.convertIndexToString('mm', a);
            }, 'right', false),
            'wcdma-l1-state-axis': module.exports.createHighChartYAxisType('wcdma-l1-state-axis', 'Lime', '', function (a) {
                return messageDescriptorConvertFactory.convertIndexToString('l1', a);
            }, 'right', false),
            'serving-cell-band-axis': module.exports.createHighChartYAxisType('serving-cell-band-axis', 'ForestGreen', '', function (a) {
                return messageDescriptorConvertFactory.convertIndexToString('servingCell', a);
            }, 'right', false),
            'gprs-state-axis': module.exports.createHighChartYAxisType('gprs-state-axis', 'Aqua', '', function (a) {
                return messageDescriptorConvertFactory.convertIndexToString('gprs', a);
            }, 'right', false),
            'modem-state-axis': module.exports.createHighChartYAxisType('modem-state-axis', 'Red', '', function (a) {
                return messageDescriptorConvertFactory.convertIndexToString('modemState', a);
            }, 'right', false),
            'operator-code-axis': module.exports.createHighChartYAxisType('operator-code-axis', 'RebeccaPurple', '', module.exports.operatorCodeToolboxfunction),
            'zero-to-fifty-seconds-axis': module.exports.createHighChartYAxisType('zero-to-fifty-seconds-axis', 'black', 's'),
            'small-number-scale-AGC': module.exports.createHighChartYAxisType('small-number-scale-AGC', 'black'),
            'highchart-axis': module.exports.createHighChartYAxisType('highchart-axis', 'orange', 'Mb', null, 'left', true, null),
            'bandwidth-MB-am': module.exports.createAxisType('bandwidth-MB-am', 'black', 110, 'MB', module.exports.bigNumberCommaSeparated, 'right'),
            'obis-loopstatus-axis': module.exports.createHighChartYAxisType('obis-loopstatus-axis', 'Lime', '', function (a) {
                return messageDescriptorConvertFactory.convertIndexToString('category', a);
            }, 'right', false),
            'obis-journeyid-axis': module.exports.createHighChartYAxisType('obis-journeyid-axis', 'Lime', '', function (a) {
                return messageDescriptorConvertFactory.convertIndexToString('journeyCode', a);
            }, 'right', false),
            'obis-swplatformstatuscode-axis': module.exports.createHighChartYAxisType('obis-swplatformstatuscode-axis', 'Lime', '', function (a) {
                return messageDescriptorConvertFactory.convertIndexToString('status', a);
            }, 'right', false),
            'obis-linename-axis': module.exports.createHighChartYAxisType('obis-linename-axis', 'Lime', '', function (a) {
                return messageDescriptorConvertFactory.convertIndexToString('name', a);
            }, 'right', false),
            'obis-tp-axis': module.exports.createHighChartYAxisType('obis-tp-axis', 'Lime', '', function (a) {
                return messageDescriptorConvertFactory.convertIndexToString('tp', a);
            }, 'right', false),
            'obis-nextstopcode-axis': module.exports.createHighChartYAxisType('obis-nextstopcode-axis', 'Lime', '', function (a) {
                return messageDescriptorConvertFactory.convertIndexToString('nextStopCode', a);
            }, 'right', false),
            'obis-nextstopname-axis': module.exports.createHighChartYAxisType('obis-nextstopname-axis', 'Lime', '', function (a) {
                return messageDescriptorConvertFactory.convertIndexToString('nextStopName', a);
            }, 'right', false),
            '5g-band-axis': module.exports.createHighChartYAxisType('5g-band-axis', 'Lime', '', function (a) {
                return messageDescriptorConvertFactory.convertIndexToString('band', a);
            }, 'right', false),
        };

        return axisTypes[type];
    },

    bytesFormater: function (value) {
        var abs = Math.abs(value);
        if (abs < 1000) {
            return module.exports.dynamictoFixed(value) + ' bytes';
        } else if (abs < 1000000) {
            return module.exports.dynamictoFixed(value / 1000) + ' kB';
        } else if (abs < 1000000000) {
            return module.exports.dynamictoFixed(value / 1000000) + ' MB';
        } else if (abs < 1000000000000) {
            return module.exports.dynamictoFixed(value / 1000000000) + ' GB';
        }
    },

    bitsFormater: function (value) {
        var abs = Math.abs(value);
        if (abs < 1000) {
            return module.exports.dynamictoFixed(value) + ' bps';
        } else if (abs < 1000000) {
            return module.exports.dynamictoFixed(value / 1000) + ' kbps';
        } else if (abs < 1000000000) {
            return module.exports.dynamictoFixed(value / 1000000) + ' Mbps';
        } else if (abs < 1000000000000) {
            return module.exports.dynamictoFixed(value / 1000000000) + ' Gbps';
        }
    },


    kbitsFormater: function (value) {
        var abs = Math.abs(value);
        if (abs < 1000) {
            return module.exports.dynamictoFixed(value) + ' kbps';
        } else if (abs < 1000000) {
            return module.exports.dynamictoFixed(value / 1000) + ' Mbps';
        } else if (abs < 1000000000) {
            return module.exports.dynamictoFixed(value / 1000000) + ' Gbps';
        } else if (abs < 1000000000000) {
            return module.exports.dynamictoFixed(value / 1000000000) + ' Tbps';
        }
    },

    dynamictoFixed: function (value) {
        if (!util.isDefined(value)) {
            return value;
        }
        if (value % 1 != 0) {
            return value.toFixed(2);
        } else {
            return value.toFixed(0);
        }
    },

    vpnUpToolboxFunction: function (value) {
        return value == 1 ? 'Up' : 'Down';
    },

    gpsUpToolboxFunction: function (value) {
        return value == 1 ? 'Gps valid' : 'Gps invalid';
    },

    lacToolboxFunction: function (value) {
        return 'lac: ' + value;
    },


    cellidToolboxFunction: function (value) {
        return 'cell-id: ' + value;
    },

    bigNumberCommaSeparated: function (value) {
        return value.toFixed(2).toLocaleString() + " MB";
    },

    microAmpereConversion: function (value) {
        return value / 1000 + ' mA'; // convert to milli
    },

    networkType2Index: function (value) {
        var returnValue;
        switch (value) {
            case 'GSM':
                returnValue = 1;
                break;

            case 'GPRS':
                returnValue = 2;
                break;

            case 'EDGE':
                returnValue = 3;
                break;

            case 'UMTS':
                returnValue = 4;
                break;

            case 'HSDPA':
                returnValue = 5;
                break;

            case 'HSUPA':
                returnValue = 6;
                break;

            case 'HSDPA/HSUPA':
                returnValue = 7;
                break;

            case 'HSPA+':
                returnValue = 8;
                break;

            case 'DC-HSPA+':
                returnValue = 9;
                break;

            case 'LTE':
                returnValue = 10;
                break;
            
            case 'FIVEGNR':
                returnValue = 11;
                break;
            
            default:
                returnValue = 0;
                break;
        }

        return returnValue;
    },


    index2networkType: function (value) {
        var returnValue;
        switch (value) {
            case 1:
                returnValue = 'GSM';
                break;

            case 2:
                returnValue = 'GPRS';
                break;

            case 3:
                returnValue = 'EDGE';
                break;

            case 4:
                returnValue = 'UMTS';
                break;

            case 5:
                returnValue = 'HSDPA';
                break;

            case 6:
                returnValue = 'HSUPA';
                break;

            case 7:
                returnValue = 'HSDPA/HSUPA';
                break;

            case 8:
                returnValue = 'HSPA+';
                break;

            case 9:
                returnValue = 'DC-HSPA+';
                break;

            case 10:
                returnValue = 'LTE';
                break;

            case 11:
                returnValue = 'FIVEGNR';
                break;

            default:
                returnValue = '-';
                break;
        }

        return returnValue;
    },


    technologyToolboxfunction: function (value) {
        var returnValue = '';

        if (value == 0) {
            return returnValue;
        }
        return module.exports.getTechnology(value);
    },

    speedUnit: function (options) {
        if (util.isDefined(options)) {
            if (util.isDefined(options.isMetric) && options.isMetric) {
                return "km/h"
            } else {
                return "mph";
            }
        } else {
            return "km/h"
        }
    },

    getTechnology: function (value) {
        var returnValue = undefined;
        switch (value) {
            case 0:
                returnValue = '-';
                break;
            case 1:
                returnValue = 'GPRS';
                break;
            case 2:
                returnValue = 'EDGE';
                break;
            case 3:
                returnValue = 'UMTS';
                break;
            case 4:
                returnValue = 'HSDPA';
                break;
            case 5:
                returnValue = 'HSUPA';
                break;
            case 6:
                returnValue = 'HSPA';
                break;
            case 7:
                returnValue = 'HSPA+';
                break;
            case 8:
                returnValue = 'LTE';
                break;
            case 9:
                returnValue = 'FIVEGNR';
                break;
            default:
                returnValue = "";
                break;
        }

        return returnValue;
    },

    operatorCodeToolboxfunction: function (value) {
        var returnValue = '-';
        if (value == 0) {
            return returnValue;
        }
        return module.exports.getOperatorCode(value);

    },

    getOperatorCode: function (value) {
        var map = operatorCodes.getOperatorCodeMap();
        var returnValue = map.get(value);
        if (!util.isDefined(returnValue)) {
            returnValue = value;
        }
        return returnValue;
    },

    formatCellTechnology: function (value) {
        var returnValue = 0;

        if (value == '-') {
            return 0;
        }

        switch (value) {
            case 'GPRS':
                returnValue = 1;
                break;
            case 'EDGE':
                returnValue = 2;
                break;
            case 'UMTS':
                returnValue = 3;
                break;
            case 'HSDPA':
                returnValue = 4;
                break;
            case 'HSUPA':
                returnValue = 5;
                break;
            case 'HSPA':
                returnValue = 6;
                break;
            case 'HSPA+':
                returnValue = 7;
                break;
            case 'LTE':
                returnValue = 8;
                break;
            case 'FIVEGNR':
                returnValue = 9;
                    break;
            default:
                returnValue = 0;
                break;
        }

        return returnValue;
    },

    getCsvExports: function () {
        return [
            {'type': "virtualusermessages", 'title': 'Virtual user statistics'},
            {'type': "trainusermessages", 'title': 'User statistics'},
            {'type': "gpsmessages", 'title': 'GPS data statistics'},
            {'type': "portalconsumption", 'title': 'Portal consumption statistics'},
            {'type': "linkstatistics", 'title': 'Link statistics'}
        ];
    }

};

